export default __webpack_public_path__ + "static/screeny-55-gp-xs-scheda-tecnica-d81433887497ae884ae52d5b59ad3fe8.pdf";